export default __webpack_public_path__ + "static/media/filter.d809ac66.svg";